// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".phone-input{height:44px;font-size:1.1em;gap:4px}.phone-input .tele-info>:first-child{width:30%}.phone-input .tele-info>:nth-child(2){width:40%}", ""]);
// Exports
module.exports = exports;
